module.exports = __webpack_public_path__ + "static/media/PDPU.a46afc98.jpg";